import { prepareCydAudio } from "./cyd-audio.js";
import { preparedAudioMetadata } from "./playlist-audio.js";
import { crc32 } from "./usb-device.js";
import { registerMedia,completeMedia } from "./api.js";
import { uploadBlob } from "./authoring.js";
import { startupSoundPath,validateStartupSound,startupSoundCommand,confirmStartupSound } from "./startup-sound.js";

export function mountStartupSound(host,{state,client,applyCloud,run,status,refresh,isCurrent}){
  const cloud=!client;
  const supported=state.features?.startupSound===true&&(!cloud||state.features?.cloudStartupSound===true);
  host.innerHTML=`<details><summary>Startup sound</summary><form><fieldset ${supported?"":"disabled"}><p>Choose a chime of up to five seconds. It plays once when this Pirdy starts. Mute, volume and quiet hours apply.</p><label>Sound<select name="choice"><option value="none">None</option>${state.startupSound?.enabled?'<option value="keep" selected>Keep saved sound</option>':""}<option value="file">Choose audio file</option></select></label><label>Audio file<input type="file" name="file" accept="audio/*,.wav,.mp3,.m4a,.aac,.flac,.ogg"/></label><button class="button primary" type="submit">Save on this Pirdy</button>${!cloud?'<button class="button" type="button" data-preview>Preview saved sound</button>':""}</fieldset><p data-sound-help></p></form></details>`;
  const form=host.querySelector("form");
  host.querySelector("[data-sound-help]").textContent=!supported?"Update this Pirdy's firmware to use startup sound with this connection.":cloud?"The sound is sent through Cloud Control and saved on this Pirdy's microSD card.":"Saved on this Pirdy's microSD card. Wi-Fi and subscriptions are not required.";
  form.elements.file.addEventListener("change",()=>{if(form.elements.file.files.length)form.elements.choice.value="file";});
  form.addEventListener("submit",event=>{event.preventDefault();void run(async()=>{
    if(!supported||!isCurrent())return;
    const choice=form.elements.choice.value;
    if(choice==="keep"){status("The saved startup sound is unchanged.");return;}
    let audio;
    try{
      if(choice==="file"){
        status("Preparing startup sound...");audio=await prepareCydAudio(form.elements.file.files[0]);validateStartupSound(audio);
        if(!isCurrent())return;
      }
      const enabled=Boolean(audio);let result;
      if(client){
        if(audio){
          await client.purpose("storage");
          try{await client.upload(startupSoundPath,audio.bytes,isCurrent);}
          finally{if(!client.faulted)await client.purpose("control");}
        }
        if(!isCurrent())return;
        result=await client.applyExperience({action:"startupSound",enabled});
      }else{
        let assetId=null;
        if(audio){
          const metadata=preparedAudioMetadata(audio,form.elements.file.files[0]?.name,crc32);
          const registered=await registerMedia(metadata);if(!isCurrent())return;
          if(registered.alreadyExists!==true){
            if(!registered.uploadUrl)throw new Error("The startup sound upload could not be prepared.");
            await uploadBlob(registered.uploadUrl,new Blob([audio.bytes],{type:"audio/wav"}));if(!isCurrent())return;
            await completeMedia(registered.assetId);if(!isCurrent())return;
          }
          assetId=registered.assetId;
        }
        result=await applyCloud(startupSoundCommand(enabled,assetId));
      }
      if(!isCurrent())return;
      confirmStartupSound(result,enabled);await refresh();status(enabled?"Startup sound saved and confirmed by Pirdy.":"Startup sound disabled. Playlist audio is unchanged.");
    }finally{audio?.bytes.fill(0);}
  });});
  const preview=host.querySelector("[data-preview]");
  if(preview){
    preview.disabled=!supported||!state.startupSound?.enabled||state.volume===0;preview.dataset.unavailable=String(preview.disabled);
    preview.addEventListener("click",()=>run(async()=>{
      if(!isCurrent())return;const result=await client.applyExperience({action:"startupSoundPreview"});
      if(!isCurrent())return;
      if(result.audio?.assetPath!==startupSoundPath||result.audio?.error)throw new Error("The saved sound preview was not confirmed.");
      status("Playing the saved startup sound at this Pirdy's volume.");
    }));
  }
}
